import { useSelector } from 'react-redux';

export default function useTableSettings() {
    const tableSettings = useSelector((state) => state.gameTable?.tableSettings);
    
    // console.log('Spruha log >>> Table Settings are >>> ', tableSettings);

    return {
        tableSettings: tableSettings || {},
    };
}
